import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private apiService: ApiService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const access_token = localStorage.getItem('access_token');
    const user_id = localStorage.getItem('user_id');

    if (!access_token || !user_id) {
      this.router.navigate(['/']);
      return of(false);
    }

    // Token exist karta hai, lekin verify karo ke abhi bhi valid hai
    return this.apiService.verifyToken(access_token).pipe(
      map(() => true),
      catchError(() => {
        this.clearSession();
        this.router.navigate(['/']);
        return of(false);
      })
    );
  }

  clearSession() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('firstname');
    localStorage.removeItem('lastname');
    localStorage.removeItem('phone');
    localStorage.removeItem('email');
    localStorage.removeItem('user_id');
    localStorage.removeItem('pg_id');
  }
}